module.exports = __webpack_public_path__ + "media/v_alerts_en.6c99dfad.mp4";